import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography,
} from '@mui/material';
import { useLegalAuth as useAuth } from '../hooks/useLegalAuth';
import { requestAccountDeletion } from './services/consentService';
import { auth } from '../firebase.config';

const DeleteAccountDialog = ({ open, onClose }) => {
  const [confirmText, setConfirmText] = useState('');
  const [showFinalConfirm, setShowFinalConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const { tenantId, currentUser } = useAuth();

  const handleTypeConfirmed = () => {
    setShowFinalConfirm(true);
  };

  const handleFinalConfirm = async () => {
    setLoading(true);
    try {
      await requestAccountDeletion(tenantId, currentUser?.email);
      await auth.signOut();
      window.location.href = '/';
    } catch (err) {
      alert(err.message || 'Something went wrong. Please contact support.');
      setLoading(false);
    }
  };

  const handleClose = () => {
    setConfirmText('');
    setShowFinalConfirm(false);
    onClose();
  };

  if (showFinalConfirm) {
    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <Typography>
            This action will begin the deletion process for your organization's account.
            This cannot be undone once the deletion process concludes.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleFinalConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Yes, proceed'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete your account?</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          This will disable your access immediately. You will no longer be able to access your account
          after this action. Deletion may take up to 30 days or more to conclude. Type DELETE to confirm.
        </Typography>
        <TextField
          fullWidth
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="DELETE"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button color="error" disabled={confirmText !== 'DELETE'} onClick={handleTypeConfirmed}>
          Delete Account
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountDialog;